import { gql } from 'apollo-angular';

export const QUERY_MAIN_MENU = gql`
  query QUERY_MAIN_MENU($where: usr_v_main_menu_bool_exp) {
    usr_v_main_menu(where: $where) {
      code
      id
      id_parent
      route
      title
      icon
      order_num
    }
  }
`;
